<template>
  <div class="year-picker">
    <button
      type="button"
      class="year-btn"
      :class="{ active: modelValue === 'all' }"
      @click="$emit('update:modelValue', 'all')"
    >
      Alla år
    </button>
    <button
      v-for="year in years"
      :key="year"
      type="button"
      class="year-btn"
      :class="{ active: modelValue === year }"
      @click="$emit('update:modelValue', year)"
    >
      {{ year }}
    </button>
  </div>
</template>
<script>
export default {
  props: {
    years: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: String,
      default: 'all'
    }
  },
  emits: ['update:modelValue']
};
</script>
<style scoped>
.year-picker {
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
}

.year-btn {
  background: #f8f8fa;
  border: 1px solid #e6e6e6;
  color: #878b9d;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.year-btn.active {
  background: var(--color-dark-blue);
  color: #fff;
  border-color: var(--color-dark-blue);
}
</style>
